<template>
	<avue-form
		ref="formUnit"
		v-model="formUnit"
		:option="optionUnit"
		:upload-after="uploadAfter"
		:upload-before="onUploadBefore"
		@submit="submitUnit"
		@reset-change="onRestChange">
		<template slot="unit_name">
			<el-autocomplete
				ref="unitName"
				v-model="formUnit.unit_name"
				:debounce="0"
				:fetch-suggestions="querySearch"
				:trigger-on-focus="true"
				clearable
				placeholder="请填写 企业名称"
				style="width: 100%"
				@clear="onUnitNameClear"
				@select="unitChanged"></el-autocomplete>
		</template>
	</avue-form>
</template>

<script>
import {checkUnit, getAreaList, getUnitHistory} from '@/api/insurance/policy'
import {getImgUrl} from '@/config/env'
import {unitCommonOption} from '@/const/crud/insurance/unitOption'
import {isAnZeProduct} from '@/util/productUtil'

export default {
	name: 'UnitCommonForm',
	props: {
		productId: {
			type: String | Number,
		},
		unitType: {
			type: String,
			required: true,
		},
		showIndustry: {
			type: Boolean,
			default: false,
		},
		showCategory: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			optionUnit: this.deepClone(unitCommonOption),
			formUnit: {
				unit_name: '',
				legal_person: '',
				unit_code: '',
				legal_person_mobile: '',
				area_code: '',
				unit_addr: '',
				bus_license: '',
				example: 'images/yyzz_sl.jpg',
			},
			//  历史网点
			unitList: [],
			selectOptions: [],
		}
	},
	watch: {
		'formUnit.area_code': {
			handler(val) {
				if (!this.validatenull(val)) {
					this.$refs['formUnit'].validateField('area_code')
				}
			},
		},
	},
	created() {
		this.getAreaList()
	},
	methods: {
		//获取dicData
		getAreaList() {
			getAreaList(3).then((response) => {
				let tempList = response.data.data
				let areaCode = this.findObject(this.optionUnit.column, 'area_code')
				areaCode.dicData = tempList
			})
		},
		querySearch(queryString, cb) {
			// this.loading = true
			this.selectOptions = []
			let query = !this.validatenull(queryString) ? {unitName: queryString} : {}
			getUnitHistory(query)
				.then((response) => {
					if (!this.validatenull(response.data.data)) {
						this.unitList = response.data.data
						this.selectOptions = this.unitList.map((item) => {
							return {
								value: item.unitName,
							}
						})
					}
				})
				.catch(() => {})
				.finally(() => {
					// this.loading = false
					cb(this.selectOptions)
				})
		},
		unitChanged(val) {
			let tempUnit = this.unitList.find(({unitName = ''}) => {
				return unitName === val.value
			})
			if (!this.validatenull(tempUnit)) {
				let {unitName, unitCode, legalPerson, legalPersonMobile, areaCode, unitAddr, busLicense} = tempUnit
				this.formUnit.unit_name = unitName
				this.formUnit.legal_person = legalPerson
				this.formUnit.unit_code = unitCode
				this.formUnit.legal_person_mobile = legalPersonMobile
				this.formUnit.area_code = [`${areaCode.substr(0, 2)}0000`, `${areaCode.substr(0, 4)}00`, areaCode]
				this.formUnit.unit_addr = unitAddr
				this.formUnit.bus_license = getImgUrl(busLicense)
				this.$nextTick(() => {
					this.$refs['formUnit'].clearValidate()
				})
			}
		},
		//清空企业名称
		onUnitNameClear() {
			this.$refs.unitName.activated = true
			this.formUnit.name = ''
			this.$refs.unitName.getData('')
		},
		//提交企业信息
		submitUnit(form, done) {
			/* insureConfirmFile:上传的投保人申请地址
       unitType：网点类型
       0--投保人、被保人
       1--投保人
       2--被保人
       3--共同被保人
       * */
			let {unit_name, legal_person, unit_code, legal_person_mobile, area_code, unit_addr, bus_license} = form
			//  校验网点信息
			let chkUnitInfo = {
				unitType: this.unitType,
				unitName: unit_name,
				unitCode: unit_code,
				unitAddress: unit_addr,
				areaCode: area_code[2],
				legalPersonMobile: legal_person_mobile,
				productId: this.productId,
			}
			checkUnit(Object.assign(chkUnitInfo))
				.then(({data: {code, originCode, originData = {}, originMsg = '', data}}) => {
					if (code !== 0 || (originCode !== '200' && originCode !== '0')) {
						this.$message.error(originMsg)
						return
					}
					if (code === 0) {
						//成功！发送数据
						this.$emit('onCheckSuccess', this.deepClone(this.formUnit))
					}
				})
				.catch(() => {})
				.finally(() => {
					done()
				})
		},
		uploadAfter(res, done, loading, column) {
			this.formUnit[column.prop] = res.url
			done()
		},
		searchBlur(e) {
			this.formUnit.name = e.target.value
		},
		getSubmitData() {
			let submitData = {
				unit_name: this.formUnit.name.replace(/\s*/g, ''),
				unit_code: this.formUnit.code,
				legal_person: this.formUnit.principal,
				legal_person_mobile: this.formUnit.mobile,
				area_code: this.formUnit.areaCode.length >= 2 ? this.formUnit.areaCode[2] : '',
				unit_addr: this.formUnit.address,
				bus_license: this.formUnit.license,
			}
			if (this.insureType === 14 && this.formUnit.certType === '100') {
				//阳光驾意险，并且为个人身份证
				submitData.unit_name = this.formUnit.name1
				submitData.unit_code = this.formUnit.code1
			}
			submitData.certType = this.formUnit.certType || ''

			if (isAnZeProduct(this.insureType)) {
				//安责
				if (this.insureType !== 18) {
					submitData.category = this.formUnit.category
					submitData.registerCapital = this.formUnit.registerCapital || ''
				} else {
					//安泽电梯
					submitData.industry = 'E'
					submitData.category = 5
					submitData.registerCapital = '200'
				}
				submitData.termType = this.formUnit.termType || ''
				submitData.termStart = this.formUnit.termStart || ''
				submitData.termEnd = this.formUnit.termEnd || ''
				let tempScope = this.formUnit.businessScope || ''
				if (!this.validatenull(tempScope) && tempScope.length > 40) {
					tempScope = tempScope.substring(0, 30)
				}
				submitData.businessScope = tempScope
				if (this.priceHintData.totalPrice >= 200000) {
					submitData.identityFront = this.formUnit.identityFront || ''
					submitData.identityBack = this.formUnit.identityBack || ''
				}
			}
			if (this.formUnit.email) {
				submitData.email = this.formUnit.email
			}
			if (this.formUnit.insureConfirmFile) {
				submitData.InsureConfirm = this.formUnit.insureConfirmFile
			}
			if (this.showIndustry) {
				submitData.industry = this.formUnit.industry
			}
			return submitData
		},
		getData() {},
		setData(data) {
			if (!this.validatenull(data)) {
				this.formUnit.name = data.unit_name
				this.formUnit.code = data.unit_code
				this.formUnit.principal = data.legal_person
				this.formUnit.mobile = data.legal_person_mobile
				this.formUnit.areaCode = []
				this.formUnit.insureConfirmFile = data.insureConfirmFile || ''

				if (!this.validatenull(data.area_code)) {
					this.formUnit.areaCode[0] = data.area_code.substr(0, 2) + '0000'
					this.formUnit.areaCode[1] = data.area_code.substr(0, 4) + '00'
					this.formUnit.areaCode[2] = data.area_code
				}
				this.formUnit.address = data.unit_addr
				this.formUnit.license = getImgUrl(data.bus_license)

				if (isAnZeProduct(this.insureType)) {
					this.formUnit.industry = data.industry || ''
					this.formUnit.category = data.category || ''
					this.formUnit.identityFront = data.identityFront || ''
					this.formUnit.identityBack = data.identityBack || ''

					this.formUnit.registerCapital = data.registerCapital || ''
					this.formUnit.termType = data.termType || ''
					this.formUnit.termStart = data.termStart || ''
					this.formUnit.termEnd = data.termEnd || ''
					this.formUnit.businessScope = data.businessScope || ''

					this.showCategoryProp(true)
				} else if (this.insureType === 13) {
					this.formUnit.email = data.email || ''
				} else if (this.insureType === 14) {
					//阳光驾意险
					this.formUnit.certType = data.certType
					if (data.certType === '100') {
						//个人身份证
						this.formUnit.name1 = data.unit_name
						this.formUnit.code1 = data.unit_code
						this.formUnit.name = ''
						this.formUnit.code = ''
					}
				} else {
					if (this.showIndustry) {
						this.formUnit.industry = data.industry
						this.showIndustryProp(true)
					}
				}
			}
			this.loading = false
		},
		onUploadBefore({type = '', size = 0}, done, loading) {
			if (type !== 'image/jpeg' && type !== 'image/png') {
				this.$message.error('上传图片只支持JPEG或PNG格式!')
				loading()
				return
			}
			if (size / 1024 / 1024 > 5) {
				this.$message.error('上传头像图片大小不能超过5MB!')
				loading()
				return
			}
			done()
		},
		//清空数据
		onRecycleData() {
			//清空数据
			if (this.$refs.formUnit) {
				this.$refs.formUnit.resetFields()
			}
		},
		onRestChange() {
			this.formUnit.example = 'images/yyzz_sl.jpg'
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger {
	width: 150px;
	border: transparent;
}
</style>
